import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'

interface P2pMarketDescriptionProps {
	description: string
}

export function P2pMarketDescription({ description }: P2pMarketDescriptionProps) {
	const [isOpen, setIsOpen] = useState(true)

	if (!description.trim()) {
		return null
	}

	return (
		<div className='w-full overflow-hidden rounded-2xl border border-border bg-card shadow-[0_4px_12px_0_hsl(var(--background)/0.2)]'>
			<button type='button' onClick={() => setIsOpen((open) => !open)} className='flex w-full items-center justify-between px-4 py-4 text-left sm:px-5'>
				<span className='text-base font-medium tracking-[-0.24px] text-foreground'>Description</span>
				<ChevronDown className={cn('h-5 w-5 text-muted-foreground transition-transform', isOpen && 'rotate-180')} />
			</button>

			{isOpen ? (
				<div className='border-t border-border px-4 pb-5 pt-4 sm:px-5'>
					<p className='whitespace-pre-wrap text-sm leading-relaxed tracking-[-0.21px] text-muted-foreground'>{description}</p>
				</div>
			) : null}
		</div>
	)
}
